// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-container[data-v-1c2b1d65]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;flex-direction:column;padding:10px}.empty-title[data-v-1c2b1d65]{color:rgba(0,0,0,.5);font-size:12px;margin:4px 0}.empty-icon[data-v-1c2b1d65]{display:inline-block;width:120px;height:120px;max-width:100%;background-size:contain;background-repeat:no-repeat;background-position:50%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
